import { render } from "./ElementCarousel.vue?vue&type=template&id=696fbf05&scoped=true"
import script from "./ElementCarousel.vue?vue&type=script&lang=js"
export * from "./ElementCarousel.vue?vue&type=script&lang=js"

import "./ElementCarousel.vue?vue&type=style&index=0&id=696fbf05&lang=scss&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-696fbf05"]])

export default __exports__